/* eslint-disable prettier/prettier */
import { PageFooterWrapper } from '@usb-ui-tools/react-billpay-layout'
import { useEffect, useReducer, useRef, useState } from 'react'
import Loader from '../../../../components/spinner'
import { BASE_PATH, googleAPIkey } from '../../../../config/connections'
import routerpath from '../../../../constants/routerpath'
import { appCache } from '../../../../context/appCache'
import {
  payeeDashbord,
  searchedBillerDetails
} from '../../../../graphql/cache/localCache'
import MobileBillPayLayout from '../../../../modules/layout/MobileBillPayLayout'
import ManualHeader from '../../../../modules/payees/add/manual/header/manual-header'
import ManualDetails from '../../../../modules/payees/add/manual/details/details'
import { routeController } from '../../../../router/routeController'
import { useMultilingualService } from '../../../../service/multilingualService'
import { useManualService } from '../../../../service/payees/add/Manual.service'
import { PageviewTealiumEvent } from '../../../../utils/tealiumwrapper'
import {
  PAGE_NAMES,
  BILLER_ACCOUNT_TYPE
} from '../../../../constants/tealiumData'
import {
  getChannelId,
  isMobileApp,
  isOLBOrIpadApp,
  isTuxApp,
  navigateRoute
} from '../../../../utils/browserutils'
import { errorMessageMappingForForm } from '../../../../utils/errorMapping'
import handleAddBillError from '../../../../utils/handleAddBillError'
import { configureNativeHeader } from '../../../../utils/nativeHandlers'
import ErrorComponent from '../../error/index'
import './manual.scss'
import {
  getSessionStorageValue,
  setSessionStorageValue
} from '../../../../utils/sessionUtils'
import { updateOnboardingFeatureNew } from '../../../../utils/poaUtils'
import { OnboardingSuccessInfoLogger } from '../../../../utils/loggerUtils'

/**
 * Add bill Manually
 *
 *
 * @returns {HTMLElement}
 */
const Manual = () => {
  const footerRef = useRef()
  const { navigateRoutePath } = navigateRoute()
  const { loadApi, loading, error, data } = useManualService()

  /* Check onboardingDeeplink */
  let fromOnboarding = false
  const onboardingDeeplink = JSON.parse(
    getSessionStorageValue('onboardingBillpayDeeplink')
  )
  if (
    onboardingDeeplink &&
    onboardingDeeplink?.source === 'digitalOnboarding'
  ) {
    fromOnboarding = true
  }
  setSessionStorageValue('fromOnboarding', fromOnboarding)

  useEffect(() => {
    payeeDashbord({ isDashboard: false })
  }, [payeeDashbord])
  // const { dataBD, loadApi: bDLoadApi } = useBillDetailDetailService()

  /**
   *add your template area alignment here
   */

  /**
   * Create state variables to update input field's value
   */
  const [pageErrorMsg, setPageErrorMsg] = useState('')
  const [isSystemError, setSystemError] = useState(false)
  const [companyTab, setCompanyTab] = useState(true)
  const [name, setName] = useState('')
  const [nickname, setNickname] = useState('')
  const [accountnumber, setAccountnumber] = useState('')
  const [phonenumber, setPhonenumber] = useState('')
  const [address1Val, setAddress1] = useState('')
  const [address2Val, setAddress2] = useState('')
  const [cityVal, setCity] = useState('')
  const [stateVal, setState] = useState('')
  const [zipcodeVal, setZipcode] = useState('')
  const [isFieldsValidationError, setFieldsValidationError] = useState(false)
  const [fieldLevelErrorData, setFieldLevelErrorData] = useState({})
  const [companyErrorCount, setCompanyErrorCount] = useState(0)
  const [personNameErrorCount, setPersonNameErrorCount] = useState(0)
  const [accountNumberErrorCount, setAccountNumberErrorCount] = useState(0)
  const [phoneNumberErrorCount, setPhoneNumberErrorCount] = useState(0)
  const [addressCollectionErrorCount, setAddressCollectionErrorCount] =
    useState(0)
  const companyRef = useRef()
  const personNameRef = useRef()
  const accountNumberRef = useRef()
  const phoneNumberRef = useRef()
  const addressCollectionRef = useRef()
  const { MESSAGE } = useMultilingualService('addBillManual')

  const ACTIONS = {
    UPDATE_COMPANY: 'update company',
    UPDATE_PERSON_NAME: 'update person name',
    UPDATE_ACCOUNT_NUMBER: 'update account number',
    UPDATE_PHONE_NUMBER: 'update phone number',
    UPDATE_ADDRESS_COLLECTION: 'update address collection',
    RESET_STATE: 'reset data'
  }

  const [formValues, dispatch] = useReducer(
    (formstate, action) => {
      switch (action.type) {
        case ACTIONS.UPDATE_COMPANY:
          return { ...formstate, company: action.payload }
        case ACTIONS.UPDATE_PERSON_NAME:
          return { ...formstate, personName: action.payload }
        case ACTIONS.UPDATE_ACCOUNT_NUMBER:
          return { ...formstate, accountNumber: action.payload }
        case ACTIONS.UPDATE_PHONE_NUMBER:
          return { ...formstate, phoneNumber: action.payload }
        case ACTIONS.UPDATE_ADDRESS_COLLECTION:
          return { ...formstate, addressCollection: action.payload }
        case ACTIONS.RESET_STATE:
          return { ...formstate, ...action.payload }
        default:
          return ''
      }
    },
    {
      company: null,
      personName: null,
      accountNumber: null,
      addressCollection: null,
      phoneNumber: null
    }
  )
  const lang = useMultilingualService('addEditErrors')

  const doFormValidate = () => {
    const errors = []

    Object.keys(formValues).forEach((value) => {
      const formValue = formValues[value]

      if (companyTab) {
        if (
          formValue === null &&
          (value === 'company' ||
            value === 'accountNumber' ||
            value === 'phoneNumber' ||
            value === 'addressCollection')
        ) {
          const message = errorMessageMappingForForm({
            value,
            pageName: 'addBillManual',
            companyTab
          })
          errors.push({ value, message })
        }
        if (formValue && value === 'addressCollection') {
          if (
            formValue.address1.errorCode !== 0 || !formValue?.address1?.inputValue ||
            formValue.city.errorCode !== 0 ||
            formValue.state.errorCode !== 0 ||
            formValue.postalCode.errorCode !== 0
          ) {
            errors.push({ value })
          }
        } else if (formValue && formValue.errorCode) {
          const message = errorMessageMappingForForm({
            value,
            pageName: 'addBillManual',
            companyTab
          })
          errors.push({ value, message })
        }
      } else {
        if (
          formValue === null &&
          (value === 'personName' ||
            value === 'phoneNumber' ||
            value === 'addressCollection')
        ) {
          const message = errorMessageMappingForForm({
            value,
            pageName: 'addBillManual',
            companyTab
          })
          errors.push({ value, message })
        }
        if (formValue && value === 'addressCollection') {
          if (
            formValue?.address1.errorCode !== 0 || !formValue?.address1?.inputValue ||
            formValue?.city.errorCode !== 0 ||
            formValue?.state.errorCode !== 0 ||
            formValue?.postalCode.errorCode !== 0
          ) {
            errors.push({ value })
          }
        } else if (
          formValue &&
          value !== 'accountNumber' &&
          formValue.errorCode !== 0
        ) {
          const message = errorMessageMappingForForm({
            value,
            pageName: 'addBillManual',
            companyTab
          })
          errors.push({ value, message })
        }
      }
    })
    return errors
  }

  const handleStatusUpdate = (status) => {
    const { inputRef } = status

    switch (inputRef?.current) {
      case companyRef.current:
        dispatch({ type: ACTIONS.UPDATE_COMPANY, payload: status })
        break
      case personNameRef.current:
        dispatch({ type: ACTIONS.UPDATE_PERSON_NAME, payload: status })
        break
      case accountNumberRef.current:
        dispatch({ type: ACTIONS.UPDATE_ACCOUNT_NUMBER, payload: status })
        break
      case phoneNumberRef.current:
        dispatch({ type: ACTIONS.UPDATE_PHONE_NUMBER, payload: status })
        break
      case addressCollectionRef.current:
        dispatch({ type: ACTIONS.UPDATE_ADDRESS_COLLECTION, payload: status })
        break
      default:
        throw new Error(`A input with the name ${inputRef} does not exist`)
    }
    /** This is when after submitting the add manually , then checking for validation
     * if there no error message then hide the page level error while onchange  itself
     */
    if (fieldLevelErrorData) {
      const errors = doFormValidate()
      if (errors.length === 0) {
        // setPageErrorMsg('')
      }
    }
  }

  const incrementErrorCounts = (errors) => {
    errors.forEach((err) => {
      switch (err.value) {
        case 'company':
          if (companyTab && companyErrorCount === 0) {
            setCompanyErrorCount(companyErrorCount + 1)
          }

          return
        case 'personName':
          if (!companyTab && personNameErrorCount === 0) {
            setPersonNameErrorCount(personNameErrorCount + 1)
          }

          return
        case 'accountNumber':
          setAccountNumberErrorCount(accountNumberErrorCount + 1)

          return
        case 'phoneNumber':
          setPhoneNumberErrorCount(phoneNumberErrorCount + 1)

          return
        case 'addressCollection':
          setAddressCollectionErrorCount(addressCollectionErrorCount + 1)

          return
        default:
          throw new Error(`No case exists for the value ${error}`)
      }
    })
  }
  const payloadReset = companyTab
    ? {
      company: null,
      personName: null,
      accountNumber: null,
      addressCollection: null,
      phoneNumber: null
    }
    : {
      personName: null,
      addressCollection: null,
      phoneNumber: null
    }
  const resetFormFields = () => {
    doFormValidate()
    setFieldsValidationError(false)
    setName('')
    setNickname('')
    setAccountnumber('')
    setPhonenumber('')
    setAddress1('')
    setAddress2('')
    setCity('')
    setState('')
    setZipcode('')
    setCompanyErrorCount(0)
    setPersonNameErrorCount(0)
    setAccountNumberErrorCount(0)
    setPhoneNumberErrorCount(0)
    setAddressCollectionErrorCount(0)
    dispatch({
      type: ACTIONS.RESET_STATE,
      payload: payloadReset
    })
  }
  // useEffect(() => {
  // applyActiveTabCss()
  // },[activeTab])
  // eslint-disable-next-line consistent-return
  const getNickName = () => {
    if (nickname) {
      return nickname
    }
  }
  // eslint-disable-next-line consistent-return
  const getAccountNumber = () => {
    if (accountnumber) {
      return [
        {
          accountNumber: accountnumber
        }
      ]
    }
  }
  /**
   * addBillManually function to add bill manually
   */
  const addBillManually = () => {
    // const errors = []
    const errors = doFormValidate()
    setPageErrorMsg('')
    
    incrementErrorCounts(errors)
    if (errors.length > 0) {
      setFieldsValidationError(true)
      if (errors.length === 1) {
        setPageErrorMsg(errors[0].message)
      }
    } else {
      setFieldsValidationError(false)
      loadApi({
        variables: {
          appName: 'BILLPAY',
          payeeCreateRequest: {
            name,
            nickName: getNickName(),
            payeeContactPhoneNumber: phonenumber,
            payeePostalAddress: {
              addressLine1: address1Val,
              addressLine2: address2Val,
              city: cityVal,
              state: stateVal,
              postalCode: zipcodeVal
            },
            payeeAccountInfo: getAccountNumber()
          }
        }
      })
    }
  }

  const cancelBillManually = () => {
    if (fromOnboarding) {
      window.location.href = `${onboardingDeeplink.redirectUrl}/billpay`
    } else {
      navigateRoutePath(`${BASE_PATH}${routerpath.pages.payeedashboard}`)
    }
  }

  const handleFooterClick = (event, type) => {
    window.scrollTo(0, 0)
    if (event && type === 'yes') {
      addBillManually()
    } else if (event && type === 'no') {
      cancelBillManually()
    }
  }

  useEffect(() => {
    // updateOnboardingFeature()
    document.title = 'Pay bills'
    appCache({ ...appCache(), Title: 'Pay bills' })
    configureNativeHeader(
      'findabilldashboard',
      true,
      BASE_PATH + routerpath.pages.manual,
      BASE_PATH + routerpath.pages.payeedashboard
    )
  }, [])

  useEffect(() => {
    const reportingData = {
      companyTab,
      billerType: BILLER_ACCOUNT_TYPE.EXTERNAL,
      accountType: BILLER_ACCOUNT_TYPE.EXTERNAL,
      transactionStatus: 'omni bill pay add biller manually start'
    }
    PageviewTealiumEvent(PAGE_NAMES.ADD_BILL_MANUALLY, reportingData)
  }, [companyTab])

  const getPayeeStatus = (payee) =>
    payee?.createBillpayPayee?.payee?.payeeStatus === 'ACTIVE'

  const handleSuccess = () => {
    OnboardingSuccessInfoLogger(
      'DIY_BILLPAY',
      'ADD_MANUAL_BILL_ENROLLMENT_SUCCESS'
    )
  }
  const handleFailure = () => {
    OnboardingSuccessInfoLogger(
      'DIY_BILLPAY',
      'ADD_MANUAL_BILL_ENROLLMENT_FAILED'
    )
  }

  const displaySuccessMsg = isOLBOrIpadApp()
    ? MESSAGE?.BILL_SETUP
    : `${name} ${MESSAGE.ADDED}`

  const navToAddBillerOrReviewDetails = isOLBOrIpadApp()
    ? routerpath.pages.addedbillerPayment
    : routerpath.pages.reviewdetails

  const linkBillDetails = isOLBOrIpadApp() ? null : routerpath.pages.billdetails

  const viewBillLink = isOLBOrIpadApp() ? null : MESSAGE?.VIEW_BILL

  const fromPayeeOrigin = fromOnboarding ? null : 'payee_management'

  useEffect(() => {
    const callPoaAndNavigateToDashboard = async () => {
      if (getPayeeStatus(data)) {
        // update POA here, add bill is success
        if (fromOnboarding) {
          await updateOnboardingFeatureNew(handleSuccess, handleFailure)
        }
        setSessionStorageValue('isBillpaySuccess', 'true')
        searchedBillerDetails({
          status: true,
          action: 'add',
          successMsg: `You have added your ${name} successfully`
        })
        const sharedData = {
          currentPath: '/',
          channel: getChannelId(),
          AppFlow: 'OPENBILLPAY',
          AppError: false,
          ReturnURL: '',
          successMsg: displaySuccessMsg,
          payeeId: data?.createBillpayPayee?.payee?.payeeId,
          navTo: navToAddBillerOrReviewDetails,
          link: viewBillLink,
          linkurl: linkBillDetails,
          fromPayee: fromPayeeOrigin,
          siderrailLoad: 'ispayeeMangement',
          type: companyTab ? 'add_company' : 'add_person',
          data
        }

        routeController(sharedData)
      }
    }
    callPoaAndNavigateToDashboard()
  }, [data])

  useEffect(() => {
    handleAddBillError(
      error,
      lang,
      setSystemError,
      setFieldsValidationError,
      setPageErrorMsg,
      setFieldLevelErrorData
    )
  }, [error])
  const { FOOTER } = useMultilingualService('addBillManual')
  if (loading || getPayeeStatus(data)) {
    return (
      <div
        data-testId="detailsloading"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          width: '100%'
        }}
      >
        <Loader />
      </div>
    )
  }
  return (
    <div className="manual">
      {!loading && !isSystemError && !getPayeeStatus(data) && (
        <PageFooterWrapper
          isOLBOrIpadApp={isOLBOrIpadApp}
          id="add-bill-manual-footer"
          ref={footerRef}
          buttonOptions={[
            {
              type: 'primary',
              text: FOOTER?.ADD_BILL_MANUALLY_ADD,
              clickEvent: (e) => {
                handleFooterClick(e, 'yes')
              },
              show: true,
              id: 'add-bill-manual-add-button'
            },
            {
              type: 'text',
              text: FOOTER?.ADD_BILL_MANUALLY_CANCEL,
              clickEvent: (e) => {
                handleFooterClick(e, 'no')
              },
              show: true,
              id: 'add-bill-manual-cancel-button'
            }
          ]}
        >
          {isTuxApp() && <MobileBillPayLayout />}
          {/* {!loading && !isSystemError && !getPayeeStatus(data) && ( */}
          <div
            style={{
              width: '100%',
              marginBottom: isMobileApp() || isTuxApp() ? '2.5rem' : ''
            }}
          >
            <ManualHeader
              {...{
                isFieldsValidationError,
                pageErrorMsg
                // combinedStyles,
                // headerStyles,
                // manualheadStyle,
                // manualsubheadStyle
              }}
            />
            <ManualDetails
              {...{
                companyErrorCount,
                accountNumberErrorCount,
                personNameErrorCount,
                companyRef,
                accountNumberRef,
                personNameRef,
                companyTab,
                accountnumber,
                setCompanyTab,
                handleStatusUpdate,
                setName,
                nickname,
                name,
                setAccountnumber,
                setNickname,
                resetFormFields,
                fieldLevelErrorData,
                phoneNumberRef,
                phoneNumberErrorCount,
                phonenumber,
                setPhonenumber,
                address1Val,
                setAddress1,
                address2Val,
                setAddress2,
                cityVal,
                stateVal,
                zipcodeVal,
                setCity,
                setState,
                setZipcode,
                addressCollectionErrorCount,
                addressCollectionRef,
                googleAPIkey,
                formValues
                // buttonOptionStyle,
                // stateZipAllignment
              }}
            />
          </div>
        </PageFooterWrapper>
      )}
      {isSystemError && <ErrorComponent />}
    </div>
  )
}

export default Manual
